export var ValueCertainty;
(function (ValueCertainty) {
    ValueCertainty[ValueCertainty["Unreliable"] = 0] = "Unreliable";
    ValueCertainty[ValueCertainty["Questionable"] = 1] = "Questionable";
    ValueCertainty[ValueCertainty["Secondary"] = 2] = "Secondary";
    ValueCertainty[ValueCertainty["Primary"] = 3] = "Primary";
})(ValueCertainty || (ValueCertainty = {}));
//# sourceMappingURL=ValueCertainty.js.map